import { toFixed } from '@wolfdanepug/js-utils'
import Box from '@mui/material/Box'

const discountContextMap: any = {
	days: 'days',
	percent: '%',
	total: '$'
}

export default function DiscountPrice({ price, context, discount }: any) {
	if (!discount) return null

	const discountPrice = price - (price * discount) / 100
	const discountContext = discountContextMap[context]
	const discountContextDisplay =
		context === 'percent' ? `${discount}${discountContext}` : `${discountContext}${discount}`

	return (
		<>
			<Box component="span" sx={styles.discount}>
				${toFixed(discountPrice, 2)}/day ({discountContextDisplay} OFF)
			</Box>
		</>
	)
}

const styles = {
	discount: {
		fontWeight: 700,
		color: 'green'
	}
}
